import { DC } from "../../constants";

const specialInfinityGlyphDisabledEffectText = () => (PelleRifts.chaos.milestones[1].canBeApplied
  ? "The Pelle-Specific effect from Infinity Glyphs is also disabled."
  : "");

export const eternityChallenges = [
  {
    id: 1,
    description: "Измерения Времени отключены.",
    goal: DC.E1800,
    goalIncrease: DC.E200,
    reward: {
      description: "Множитель Измерений Времени, основанный на времени, проведённом в этой Вечности",
      effect: completions =>
        Decimal.pow(Math.max(player.records.thisEternity.time / 10, 0.9), 0.3 + (completions * 0.05)),
      formatEffect: value => formatX(value, 2, 1)
    },
    // These will get notation-formatted and scrambled between for the final goal
    scrambleText: ["1e2600", "1e201600"],
  },
  {
    id: 2,
    description: "Измерения Бесконечности отключены.",
    goal: DC.E975,
    pelleGoal: DC.E1750,
    goalIncrease: DC.E175,
    reward: {
      description: "Множитель 1ого Измерения Бесконечности, основанный на Мощности Бесконечности",
      effect: completions => Currency.infinityPower.value.pow(1.5 / (700 - completions * 100)).clampMin(1),
      cap: DC.E100,
      formatEffect: value => formatX(value, 2, 1)
    }
  },
  {
    id: 3,
    description: "Измерения Антиматерии 5-8 ничего не производят. Жертвование Измерений отключено.",
    goal: DC.E600,
    pelleGoal: DC.E925,
    goalIncrease: DC.E75,
    reward: {
      description: () => `Увеличение множителя за покупку ${formatInt(10)} Измерений Антиматерии`,
      effect: completions => completions * 0.72,
      formatEffect: value => `+${format(value, 2, 2)}`
    }
  },
  {
    id: 4,
    description: `Все множители Бесконечности и генераторы отключены. Цель должна быть достигнута за определённое
      количество Бесконечностей, иначе вы провалите Челлендж.`,
    goal: DC.E2750,
    goalIncrease: DC.E550,
    restriction: completions => Math.max(16 - 4 * completions, 0),
    checkRestriction: restriction => Currency.infinities.lte(restriction),
    formatRestriction: restriction => (restriction === 0
      ? "без Бесконечностей"
      : `за ${ruQuantifyInt("Бесконечность,Бесконечности,Бесконечностей", restriction)} или меньше`),
    failedRestriction: "(Слишком много Бесконечностей для большего)",
    reward: {
      description: "Множитель Измерений Бесконечности, основанный на непотраченных ОБ",
      effect: completions => Currency.infinityPoints.value.pow(0.003 + completions * 0.002),
      cap: DC.E200,
      formatEffect: value => formatX(value, 2, 1)
    }
  },
  {
    id: 5,
    description: () => `Увеличение масштабирования цен Галактик Антиматерии начинается сразу (обычно на
    ${formatInt(100)} Галактиках). Масштабирование цен Бустов Измерений сильно повышено.`,
    goal: DC.E750,
    pelleGoal: DC.E1400,
    goalIncrease: DC.E400,
    reward: {
      description: "Масштабирование цен Далёких Галактик начинается позднее",
      effect: completions => completions * 5,
      formatEffect: value => `на ${formatInt(value)} ГА`
    }
  },
  {
    id: 6,
    // The asterisk, if present, will get replaced with strings generated from the scramble text
    description: () => {
      if (Enslaved.isRunning) return "Вы *. Цена улучшения максимального количества Галактик Репликантов значительно " +
        "уменьшена.";
      return "Вы не можете получать Галактики Антиматерии обычным образом. Цена улучшения максимального " +
              "количества Галактик Репликантов значительно уменьшена.";
    },
    goal: DC.E850,
    pelleGoal: DC.E1500,
    goalIncrease: DC.E250,
    reward: {
      description: "Больше уменьшить рост цены множителя Измерений Антиматерии",
      effect: completions => completions * 0.2,
      formatEffect: value => {
        const total = Math.round(Player.dimensionMultDecrease + Effects.sum(EternityChallenge(6).reward)) - value;
        return `-${format(value, 2, 1)} (${formatX(total, 2, 1)} всего)`;
      }
    },
    scrambleText: ["не можете получать Галактики Антиматерии обычным образом", "н㏰'퐚 пол鸭 Анти꟢ма랜тﻪﶓи⁍акт㮾 䂇обы㦂р"],
  },
  {
    id: 7,
    description:
      "1ые Измерения Времени производят 8ые Измерения Бесконечности, а 1ые Измерения Бесконечности производят " +
      "7ые Измерения Антиматерии. Скорость Тика также напрямую влияет на Измерения Бесконечности и Времени.",
    goal: DC.E2000,
    pelleGoal: DC.E2700,
    goalIncrease: DC.E530,
    effect: () => TimeDimension(1).productionPerSecond,
    reward: {
      description: "1ые Измерения Времени производят 8ые Измерения Бесконечности",
      effect: completions => TimeDimension(1).productionPerSecond.pow(completions * 0.2).minus(1).clampMin(0),
      formatEffect: value => `${format(value, 2, 1)} в секунду`
    }
  },
  {
    id: 8,
    description: () => `вы можете улучшить Измерения Бесконечности только ${formatInt(50)} раз, а Репликантов
      ${formatInt(40)} раз. АвтоПокупщики Измерений Бесконечности и улучшений Репликантов отключены.`,
    goal: DC.E1300,
    pelleGoal: DC.E2800,
    goalIncrease: DC.E900,
    reward: {
      description: "Мощность Бесконечности усиливает Галактики Репликантов",
      effect: completions => {
        const infinityPower = Math.log10(Currency.infinityPower.value.pLog10() + 1);
        return Math.max(0, Math.pow(infinityPower, 0.03 * completions) - 1);
      },
      formatEffect: value => formatPercents(value, 2)
    }
  },
  {
    id: 9,
    description: () => `Вы не можете покупать улучшения Скорости Тика. Взамен, Мощность Бесконечности умножает
      Временные Измерения с значительно уменьшенным эффектом. ${specialInfinityGlyphDisabledEffectText()}`,
    goal: DC.E1750,
    pelleGoal: DC.E2900,
    goalIncrease: DC.E250,
    reward: {
      description: "Множитель Измерений Бесконечности, основанный на Осколках Времени",
      effect: completions => Currency.timeShards.value.pow(completions * 0.1).clampMin(1),
      cap: DC.E400,
      formatEffect: value => formatX(value, 2, 1)
    }
  },
  {
    id: 10,
    description: () => {
      let description = `Измерения Времени и Измерения Бесконечности отключены. Вы получаете огромный бонус от к
        Измерениям Антиматерии от Бесконечностей (Бесконечности${formatPow(950)}). ${
  specialInfinityGlyphDisabledEffectText()}`;
      EternityChallenge(10).applyEffect(v => description += ` Сейчас: ${formatX(v, 2, 1)}`);
      return description;
    },
    goal: DC.E3000,
    pelleGoal: DC.E3200,
    goalIncrease: DC.E300,
    effect: () => Decimal.pow(Currency.infinitiesTotal.value, 950).clampMin(1).pow(TimeStudy(31).effectOrDefault(1)),
    reward: {
      description: "Множитель Измерений Времени, основанный на Бесконечностях",
      effect: completions => {
        const mult = Currency.infinitiesTotal.value.times(2.783e-6).pow(0.4 + 0.1 * completions).clampMin(1);
        return mult.powEffectOf(TimeStudy(31));
      },
      formatEffect: value => {
        // Since TS31 is already accounted for in the effect prop, we need to "undo" it to display the base value here
        const mult = formatX(value, 2, 1);
        return TimeStudy(31).canBeApplied
          ? `${formatX(value.pow(1 / TimeStudy(31).effectValue), 2, 1)} (После ВИ31: ${mult})`
          : mult;
      }
    }
  },
  {
    id: 11,
    description: () => `Все Множители Измерений и степени отключены, за исключением множителей от Мощности
      Бесконечности и Бустов Измерений (к Измерениям Антиматерии). ${specialInfinityGlyphDisabledEffectText()}`,
    goal: DC.E450,
    pelleGoal: DC.E11200,
    goalIncrease: DC.E200,
    pelleGoalIncrease: DC.E1400,
    reward: {
      description: "Ещё больше уменьшить рост цена множителя Скорости Тика",
      effect: completions => completions * 0.07,
      formatEffect: value => {
        const total = Math.round(Player.tickSpeedMultDecrease + Effects.sum(EternityChallenge(11).reward)) - value;
        return `-${format(value, 2, 2)} (${formatX(total, 2, 2)} total)`;
      }
    }
  },
  {
    id: 12,
    description: () => (PlayerProgress.realityUnlocked()
      ? `игра работает в ×${formatInt(1000)} раз медленнее; все остальные эффекты, влияющие на скорость игры, отключены.
      Цель должна быть достигнута за определённое количество времени, иначе вы провалите Челлендж.
        ${specialInfinityGlyphDisabledEffectText()}`
      : `игра работает в ×${formatInt(1000)} раз медленнее. Цель должна быть достигнута за определённое количество
        времени, иначе вы провалите Челлендж.`),
    goal: DC.E110000,
    pelleGoal: DC.E208000,
    goalIncrease: DC.E12000,
    restriction: completions => Math.max(10 - 2 * completions, 1) / 10,
    checkRestriction: restriction => Time.thisEternity.totalSeconds < restriction,
    formatRestriction: restriction => `за ${ruQuantify(
      "внутриигровую секунду,внутриигровых секунды,внутриигровых секунд", restriction, 0, 1)} или меньше.`,
    failedRestriction: "(Слишком медленно для большего)",
    reward: {
      description: "Множители цен Измерений Бесконечности уменьшены",
      effect: completions => 1 - completions * 0.008,
      formatEffect: value => `x${formatPow(value, 3, 3)}`
    }
  }
];
